import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateYourOwnUser } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import queryKeys from '@/queries/queryKeys';

export default function useUpdateMetadata() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (metadata: Record<string, unknown>) =>
      updateYourOwnUser(
        {
          body: {
            metadata,
          },
        },
        wgApi,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.me() });
    },
  });
}
